import React from 'react';
import Cookies from 'js-cookie';

const ShareASaleLeadPixel = ({ shareASaleHash = false, transType = "lead", xtype = false }) => {
  return <></>
  const pixelCookie = Cookies.get('pixelCookie') ? Cookies.get('pixelCookie') : false;
  let sfLeadID = Cookies.get('SFLeadID') ? Cookies.get('SFLeadID') : false;
  console.log(sfLeadID)
  if (!pixelCookie && sfLeadID && shareASaleHash) {
    const merchantId = process.env.SHAS_MERCHANTID ? process.env.SHAS_MERCHANTID : "104229";
    let leadPixelUrl = "https://www.shareasale.com/sale.cfm?tracking=" + sfLeadID + "&amount=0.00&merchantID=" + merchantId + "&transtype=" + transType
    if (xtype) {
      leadPixelUrl = leadPixelUrl + "&xtype=" + xtype
    }
    Cookies.set('pixelCookie', true)
    console.log(leadPixelUrl)
    return (
      <div className='shareasale-pixel' style={{ height: '1px' }}>
        <img id='_SHRSL_img_1' src={leadPixelUrl} width='1' height='1' />
        <script src='https://www.dwin1.com/19038.js' type='text/javascript' defer='defer'></script>
      </div>
    );
  } else {
    //The pixel should only be printed once
    return <></>
  }

};

export default ShareASaleLeadPixel;
